import type { Nullable } from "@/types";

export function requireElement<T extends HTMLElement>(
  value: Nullable<T>,
  label: string,
): T {
  if (value == null) {
    throw new Error(`Missing DOM node: ${label}`);
  }
  return value;
}
